// extracted by mini-css-extract-plugin
module.exports = {"cardDiv":"SideCard_cardDiv__2BXsH","titleSty":"SideCard_titleSty__1AW5q"};